<div class="administration no-network">
  @if (!showNetworkAvailableBanner()) {
    <div>
      <div class="no-network-header">
        <tds-icon [name]="'wifi_inactive'" [size]="'18px'"></tds-icon>
        <h3>{{ 'DuÄrOffline' | translate }}</h3>
      </div>
      <div class="no-network-body">
        <!-- Check your internet connection. -->
        <p>{{ 'KontrolleraDinInternetanslutning_' | translate }}</p>
      </div>
    </div>
  } @else {
    <div>
      <div class="no-network-header">
        <spinner-loader></spinner-loader>
        <h3>Network is available</h3>
      </div>
      <div class="no-network-body">
        <!-- The internet connection is working again. -->
        <p>{{ 'InternetanslutningenFungerarIgen_' | translate }}</p>
      </div>
    </div>
  }
</div>
